<li class="list-flat-item-icon">
    <svg *ngIf="parent.icon === 'check'" class="svg-icon svg-icon--xs list-flat-item-icon__check"><use href="assets/icons-ui.svg#check-closed"></use></svg>
    <svg *ngIf="parent.icon === 'cross'" class="svg-icon svg-icon--xs list-flat-item-icon__cross"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
    <svg *ngIf="parent.icon === 'dot'" class="svg-icon svg-icon--xs list-flat-item-icon__dot"><use href="assets/icons-ui.svg#bullet"></use></svg>
    <svg *ngIf="parent.icon === 'arrow'" class="svg-icon svg-icon--xs list-flat-item-icon__arrow"><use href="assets/icons-ui.svg#rechts-open"></use></svg>
    <ng-content></ng-content>
</li>
